import { FormRow } from "..";
import { useAppContext } from "../../context/appContext";
import Wrapper from "../../assets/wrappers/AddItemLocation";
import { useTranslation } from "react-i18next";

const AddItemLocation = () => {
  const {
    isLoading,
    isAddingLocation,
    isEditingLocation,
    displayAlert,
    locationName,
    handleChange,
    createItemLocation,
    editItemLocation,
    editItemLocationId,
    deleteItemLocation,
  } = useAppContext();
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!locationName) {
      displayAlert();
      return;
    }
    if (isEditingLocation) {
      editItemLocation();
      return;
    }
    createItemLocation();
  };

  const handleItemInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({ name, value });
  };

  return (
    <Wrapper>
      <form className={isAddingLocation ? "form_active" : "form"}>
        {/* <h6>{isEditingLocation ? "edit location" : "add location"} </h6> */}
        <div className="form-center">
          <FormRow
            type="text"
            name="locationName"
            value={locationName}
            handleChange={handleItemInput}
            labelText={t("Location Name")}
          />
          <div className="btn-container">
            <button
              type="submit"
              className="btn btn-block submit-btn"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {t("Submit")}
            </button>

            {isEditingLocation && (
              <button
                type="button"
                className="btn delete-btn"
                onClick={() => deleteItemLocation(editItemLocationId)}
              >
                {t("Delete")}
              </button>
            )}
          </div>
        </div>
      </form>
    </Wrapper>
  );
};

export default AddItemLocation;
